import PaywallView from "../Views/Subscription/PaywallView.vue";
import SubscriptionSuccess from "../Views/Subscription/SubscriptionSuccess.vue";
import SubscriptionManage from "../Views/Subscription/SubscriptionManage.vue";

export const subscriptionRoutes = [
    {
        path: "/subscription/paywall",
        name: "subscription.paywall",
        component: PaywallView,
        meta: {
            menu: {
                parent: 'subscription',
                child: null
            },
            breadcrumb: {
                title: "Abonnement",
                nav: {
                    all: {
                        active: "Choisir un plan",
                        inactive: []
                    }
                }
            }
        },
    },
    {
        path: "/subscription/success",
        name: "subscription.success",
        component: SubscriptionSuccess,
        meta: {
            menu: {
                parent: 'subscription',
                child: null
            },
            breadcrumb: {
                title: "Abonnement",
                nav: {
                    all: {
                        active: "Confirmation",
                        inactive: []
                    }
                }
            }
        },
    },
    {
        path: "/subscription/manage",
        name: "subscription.manage",
        component: SubscriptionManage,
        meta: {
            menu: {
                parent: 'subscription',
                child: null
            },
            breadcrumb: {
                title: "Abonnement",
                nav: {
                    all: {
                        active: "Gérer mon abonnement",
                        inactive: []
                    }
                }
            }
        },
    },
];
